import { motion } from "framer-motion";
import { Gem, HeartHandshake, BadgePercent } from "lucide-react";

const ABOUT_IMAGE = "/gallery/work-3.webp";

const PILLARS = [
  {
    icon: Gem,
    title: "Quality that lasts",
    text: "Nails that stay perfect for weeks, not days.",
    testid: "pillar-quality",
  },
  {
    icon: HeartHandshake,
    title: "Friendly & relaxed",
    text: "A warm atmosphere with personal attention — you're never rushed.",
    testid: "pillar-atmosphere",
  },
  {
    icon: BadgePercent,
    title: "Great prices",
    text: "Premium quality work at prices that feel fair.",
    testid: "pillar-prices",
  },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-white py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 md:px-12 lg:grid-cols-2 lg:gap-24">
      <motion.div
        initial={{ opacity: 0, x: -32 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative"
      >
        <div className="overflow-hidden rounded-[2rem] shadow-[0_24px_64px_rgba(45,27,34,0.1)]">
          <img
            src={ABOUT_IMAGE}
            alt="White and black French tip set by Teo's Nails"
            data-testid="about-image"
            loading="lazy"
            className="aspect-[4/5] w-full object-cover"
          />
        </div>
        <div className="absolute -right-6 -top-6 -z-10 h-40 w-40 rounded-[2rem] bg-brand-muted" />
      </motion.div>
      <div>
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-brand-accent">The Salon</p>
        <h2 className="font-display text-4xl font-medium tracking-tight text-brand-ink md:text-5xl">
          Why our clients keep coming back
        </h2>
        <p className="mt-6 text-base leading-relaxed text-brand-ink/70 md:text-lg">
          We pride ourselves on quality that lasts — giving you nails that stay perfect for weeks. Enjoy our
          friendly, relaxed atmosphere, personal attention, and great prices for premium work.
        </p>
        <div className="mt-12 space-y-8">
          {PILLARS.map((pillar, i) => (
            <motion.div
              key={pillar.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: 0.1 * i }}
              data-testid={pillar.testid}
              className="flex items-start gap-5"
            >
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-ground">
                <pillar.icon className="h-5 w-5 text-brand-accent" />
              </div>
              <div>
                <h3 className="font-display text-xl font-semibold text-brand-ink">{pillar.title}</h3>
                <p className="mt-1 text-base leading-relaxed text-brand-ink/70">{pillar.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
